import useFetchList from '../../../elements/Hooks/useFetchList'
import useModalShow from '../../../elements/Hooks/useModalShow'
import { isEmpty, get } from 'lodash'
import moment from 'moment'
import React, { Fragment } from 'react'
import { Button } from 'antd'
import BankingModal from './Modal/Banking'
import { streamUrl } from '../../../variables/index'
import Auth from '../../../modules/Authentication'
import Employees from '../../../api/Employees'
import ViewDownload from '../../../elements/ViewDownload'
import CustomTable from '../../../elements/Table/CustomTable'

const EmployeesAPI = new Employees()
const auth = new Auth()

function Banking(props) {
  const { member, employee } = props

  const { list: banks, fetching, fetch } = useFetchList(
    () => EmployeesAPI.banks.list(employee._key),
    [employee._key],
    isEmpty(employee._key),
  )

  console.log(banks)

  const {
    visible,
    onShow,
    onCancel,
    payload: { object: bank, type },
  } = useModalShow()

  const columns = [
    {
      Header: 'Nickname',
      accessor: 'nickname',
      Cell: ({ value, original }) => <a onClick={e => onShow(original, 'edit')}>{value}</a>,
    },
    {
      Header: 'Account',
      accessor: 'accname',
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Bank',
      accessor: 'bank.name',
    },
    {
      Header: 'SWIFT',
      accessor: 'bank.swift',
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'BSB/SORT',
      accessor: 'bank.bsb',
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Country',
      accessor: 'bank.country',
    },
    { Header: 'Currency', accessor: 'currency' },
    {
      Header: 'Account Number',
      accessor: 'number',
      Cell: ({ value }) => value && new Array(11).join('*') + value.slice(-4),
    },
    {
      Header: 'IBAN',
      accessor: 'iban',
      hideable: true,
      hideDefault: true,
    },
    { Header: 'Status', accessor: 'status' },
    {
      Header: 'File',
      accessor: 'file',
      Cell: ({ value }) =>
        value && (
          <ViewDownload
            view={`${streamUrl}files/${value}?action=view&access_token=${auth.getAccessToken()}`}
            download={`${streamUrl}files/${value}?action=download&access_token=${auth.getAccessToken()}`}
          />
        ),
    },
  ]

  console.log({ member, employee, fetching })
  return (
    <Fragment>
      <BankingModal
        key={get(bank, '_key', moment().unix())}
        employee={employee}
        bank={bank}
        member={member}
        type={type}
        visible={visible}
        handleCancel={() => {
          onCancel()
          fetch()
        }}
      />
      <CustomTable
        CreateButton={() => (
          <Button
            onClick={() => onShow({ _key: moment().unix() }, 'new')}
            size={'small'}
            type="primary"
            icon="user-add">
            New
          </Button>
        )}
        fetch={fetch}
        columns={columns}
        loading={fetching}
        data={banks}
      />
    </Fragment>
  )
}

export default Banking
